<template>
  <section class="mx-auto max-w-7xl px-4 pb-16 sm:px-6 lg:px-8">
    <div
      class="relative overflow-hidden rounded-3xl p-10 sm:p-16 lg:grid lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-12"
      style="background: linear-gradient(120deg, #2e1d5e 0%, #53389e 45%, #7f56d9 100%)"
    >
      <!-- Dot grid overlay -->
      <div
        class="pointer-events-none absolute inset-0"
        style="
          background-image: radial-gradient(rgba(255, 255, 255, 0.22) 1px, transparent 1.5px);
          background-size: 22px 22px;
          -webkit-mask-image: linear-gradient(115deg, rgba(0, 0, 0, 0.9), transparent 65%);
          mask-image: linear-gradient(115deg, rgba(0, 0, 0, 0.9), transparent 65%);
        "
        aria-hidden="true"
      />
      <!-- Glow orb 1 -->
      <div
        class="pointer-events-none absolute -right-36 -top-56 size-[520px] rounded-full"
        style="background: radial-gradient(closest-side, rgba(182, 146, 246, 0.55), rgba(182, 146, 246, 0))"
        aria-hidden="true"
      />
      <!-- Glow orb 2 -->
      <div
        class="pointer-events-none absolute -bottom-64 -left-48 size-[520px] rounded-full"
        style="background: radial-gradient(closest-side, rgba(94, 234, 212, 0.28), rgba(94, 234, 212, 0))"
        aria-hidden="true"
      />

      <!-- Copy column -->
      <div class="relative flex flex-col items-start gap-6">
        <span class="text-sm font-semibold text-primary-200"> Free to try · no card · no per-postcard fee </span>
        <h2 class="text-pretty text-3xl font-semibold text-white sm:text-4xl sm:tracking-[-0.5px] lg:text-balance lg:text-[40px] lg:leading-[1.2]">
          Ship a postcard editor this week.
        </h2>
        <p class="max-w-[48ch] text-lg text-primary-100">
          Try the editor right now without an account. When you're ready, embed it in an afternoon or book twenty minutes and we'll walk through it
          with your team.
        </p>
        <!-- CTAs -->
        <div class="flex flex-wrap gap-3">
          <Link
            href="/signup"
            class="flex items-center gap-2 rounded-lg bg-white px-5 py-2.5 text-sm font-semibold text-primary-800 shadow-[0px_8px_24px_-8px_rgba(0,0,0,0.4)] transition hover:bg-primary-50"
          >
            Try the editor
          </Link>
          <button
            type="button"
            class="flex items-center gap-2 rounded-lg border border-white/35 bg-white/10 px-5 py-2.5 text-sm font-semibold text-white backdrop-blur-sm transition hover:bg-white/20"
            @click="showDemoDialog = true"
          >
            Book a 20-minute demo
          </button>
        </div>
        <!-- Trust signals -->
        <div class="flex flex-wrap gap-x-5 gap-y-2">
          <span
            v-for="trust in trustSignals"
            :key="trust"
            class="flex items-center gap-2 text-sm text-primary-100"
          >
            <svg
              class="size-4 shrink-0 text-[#5EEAD4]"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true"
            >
              <path d="M5 12l5 5L20 7" />
            </svg>
            {{ trust }}
          </span>
        </div>
      </div>
    </div>

    <BookDemoDialog v-model:show="showDemoDialog" />
  </section>
</template>

<script setup lang="ts">
import { ref } from "vue";
import { Link } from "@inertiajs/vue3";
import BookDemoDialog from "@/Components/Welcome/BookDemoDialog.vue";

const showDemoDialog = ref(false);

const trustSignals = ["Passes Lob and PostGrid preflight", "Cancel any time", "Sandbox keys never expire"];
</script>
